import styled from 'styled-components';
import { useState } from 'react';
import { ComiteMiembrosPopup } from './ComiteMiembrosPopup';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getComiteMiembros, useComite } from '../../../../../appStore/comite';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { useActas, cleanMsg, getActaFile, getFirmas } from '../../../../../appStore/actas';
import { SuccessErrorDlg } from '../../../../CompUtils/SuccessErrorDlg';
import FullLoading from '../../../../CompUtils/FullLoading';
import { Button } from 'react-bootstrap';

const CenteredDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const GenerarAprobacion = () => {
  const [showVeedores, setShowVeedores] = useState(false);
  const dispatch = useDispatch();
  const { idLlamadoConcurso } = useConcurso();

  const { loading } = useComite();
  const { success, error, loading: actaLoading, actas } = useActas();

  useEffect(() => {
    dispatch(getFirmas({ idLlamadoConcurso }));
    dispatch(getComiteMiembros({ idLlamadoConcurso }));
  }, [dispatch, idLlamadoConcurso]);

  useEffect(() => {
    setShowVeedores(false);
  }, [success, error]);

  const [primeracta] = actas || [];
  useEffect(() => {
    if (primeracta) {
      dispatch(getActaFile({ idActaConcurso: primeracta.idActaConcurso }));
    }
  }, [dispatch, primeracta]);

  return (
    <CenteredDiv>
      <FullLoading show={actaLoading} />
      <ComiteMiembrosPopup
        open={showVeedores && !actaLoading}
        onClose={() => setShowVeedores(false)}
      />
      {!primeracta && (
        <Button disabled={loading} onClick={() => setShowVeedores(true)} variant="primary">
          Generar aprobación de bases
        </Button>
      )}
      <SuccessErrorDlg success={success} error={error} onClose={() => dispatch(cleanMsg())} />
    </CenteredDiv>
  );
};
